import { v4 as uuidv4 } from 'uuid'
import Vue from 'vue'

import { DEFAULT_ROUTES_COUNT_PER_PAGE } from '@/modules/dispatcher/constants/routes'
import { $themeConfig } from '@themeConfig'

const ROUTE_URL = `${$themeConfig.app.backUrl}/routes`

export function fetchRoutes(divisionId, params, signal) {
    if (!divisionId) {
        throw new Error('fetchRoutes: обязателен параметр divisionId')
    }

    return Vue.axios.get(ROUTE_URL, {
        params: {
            ...(params.start_date && { start_date: params.start_date }),
            ...(params.end_date && { end_date: params.end_date }),
            ...(params.status && { status: params.status }),
            ...(params.courier_id && { courier_id: params.courier_id }),
            ...(params.order_number && { order_number: params.order_number }),
            ...(params.shift_id && { shift_id: params.shift_id }),
            page: params.page ?? 1,
            page_size: params.page_size ?? DEFAULT_ROUTES_COUNT_PER_PAGE,
            division_id: divisionId,
        },
        ...(signal ? { signal } : {}),
    })
}

export function fetchRouteStatuses(divisionId, params, signal) {
    if (!divisionId) {
        throw new Error('fetchRouteStatuses: обязателен параметр divisionId')
    }

    return Vue.axios.get(`${ROUTE_URL}/statuses`, {
        params: {
            ...(params.start_date && { start_date: params.start_date }),
            ...(params.end_date && { end_date: params.end_date }),
            ...(params.courier_id && { courier_id: params.courier_id }),
            ...(params.order_number && { order_number: params.order_number }),
            ...(params.shift_id && { shift_id: params.shift_id }),
            division_id: divisionId,
        },
        ...(signal ? { signal } : {}),
    })
}

export function createRoute(divisionId, params) {
    if (!params.date)
        throw new Error('createRoute: params.date обязателеный параметр')

    if (!divisionId) {
        throw new Error('createRoute: обязателен параметр divisionId')
    }

    return Vue.axios.post(ROUTE_URL, {
        date: params.date,
        division_id: divisionId,
    })
}

export function deleteRoute(routeId) {
    if (!routeId) throw new Error('deleteRoute: routeId обязательный параметр')
    return Vue.axios.delete(`${ROUTE_URL}/${routeId}`)
}

export function addOrdersToRoute(routeId, orderIds, idempotencyKey) {
    const headers = {}
    if (idempotencyKey) {
        headers['Idempotency-Key'] = idempotencyKey
    }
    return Vue.axios.post(
        `${ROUTE_URL}/${routeId}/orders/add`,
        { order_ids: orderIds },
        { headers }
    )
}

export function transferOrdersToRoute(
    sourceRouteId,
    targetRouteId,
    orderIds,
    idempotencyKey
) {
    if (!sourceRouteId) {
        throw new Error(
            'transferOrdersToRoute: sourceRouteId обязательный параметр'
        )
    }

    if (!targetRouteId) {
        throw new Error(
            'transferOrdersToRoute: targetRouteId обязательный параметр'
        )
    }

    if (!Array.isArray(orderIds) || orderIds.length === 0) {
        throw new Error('transferOrdersToRoute: orderIds обязательный параметр')
    }

    const headers = {}
    if (idempotencyKey) {
        headers['Idempotency-Key'] = idempotencyKey
    }

    return Vue.axios.post(
        `${ROUTE_URL}/${sourceRouteId}/orders/transfer`,
        {
            order_ids: orderIds,
            target_route_id: targetRouteId,
        },
        { headers }
    )
}

export function removeOrdersFromRoute(routeId, orderIds) {
    if (!routeId) {
        throw new Error('removeOrdersFromRoute: routeId обязательный параметр')
    }

    if (!Array.isArray(orderIds) || orderIds.length === 0) {
        throw new Error('removeOrdersFromRoute: orderIds обязательный параметр')
    }

    return Vue.axios.post(`${ROUTE_URL}/${routeId}/orders/remove`, {
        order_ids: orderIds,
    })
}

export function assignCourier(routeId, courierId) {
    if (!routeId)
        throw new Error('assignCourier: routeId обязательный параметр')
    if (!courierId)
        throw new Error('assignCourier: courier обязательный параметр')

    return Vue.axios.post(
        `${ROUTE_URL}/${routeId}/assign`,
        {
            courier_id: courierId,
        },
        {
            headers: {
                'Idempotency-Key': uuidv4(),
            },
        }
    )
}

export function unassignCourier(routeId) {
    if (!routeId)
        throw new Error('unassignCourier: routeId обязательный параметр')

    return Vue.axios.post(
        `${ROUTE_URL}/${routeId}/unassign`,
        {},
        {
            headers: {
                'Idempotency-Key': uuidv4(),
            },
        }
    )
}

export function startRoute(routeId, orders) {
    if (!routeId) throw new Error('startRoute: routeId обязательный параметр')
    return Vue.axios.post(
        `${ROUTE_URL}/${routeId}/start`,
        {
            orders,
        },
        {
            headers: {
                'Idempotency-Key': uuidv4(),
            },
        }
    )
}

export function completeRoute(routeId, { force = false } = {}) {
    if (!routeId)
        throw new Error('completeRoute: routeId обязательный параметр')
    return Vue.axios.post(
        `${ROUTE_URL}/${routeId}/complete`,
        { force },
        {
            headers: {
                'Idempotency-Key': uuidv4(),
            },
        }
    )
}
